import ContactComp from "../components/ContactComp";
import PageHeader from "../components/PageHeader";

const Contact = () => {
  return (
    <>
      <PageHeader />
      <ContactComp />
    </>
  );
};

export default Contact;
